const parseServices = services => {
  if (services)
    return services.map(entry => ({
      ...entry,
      service_attr: JSON.parse(entry.service_attr)
    }));
  return [];
};
export default parseServices;
